module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-compact-979b9b0b678311b4cd78db1f6f18297c.png";